import {useMutation} from "@tanstack/react-query";

import {deleteServiceFunctionMutationOptions} from "./delete-service-function.mutation-options";

export function useDeleteServiceFunction() {
  return useMutation(deleteServiceFunctionMutationOptions());
}
